export const passwordRules = (fieldName = "Password") => ({
  required: {
    value: true,
    message: `${fieldName} is required`,
  },
  minLength: {
    value: 8,
    message: `${fieldName} must be at least 8 characters`,
  },
  validate: {
    hasNumber: (value: string) => (/.*[0-9].*/.test(value) ? true : `${fieldName} must have a number`),
    hasUppercase: (value: string) => (/.*[A-Z].*/.test(value) ? true : `${fieldName} must have a uppercase letter`),
    hasLowercase: (value: string) => (/.*[a-z].*/.test(value) ? true : `${fieldName} must have a lowercase letter`),
  },
});

export const phoneRules = (fieldName = "Phone") => ({
  pattern: {
    value: /^\d+$/,
    message: `${fieldName} must be a number`,
  },
});

export const emailRules = () => ({
  required: {
    value: true,
    message: `Email is required`,
  },
  pattern: {
    value: /\S+@\S+\.\S+/,
    message: `Email is invalid`,
  },
});

export const firstNameRules = () => ({
  required: {
    value: true,
    message: `First name is required`,
  },
  maxLength: {
    value: 50,
    message: `First name must be 50 characters or less`,
  },
  pattern: {
    value: /^[A-Za-z\s-']+$/,
    message: `First name can only contain letters, spaces, hyphens, and apostrophes`,
  },
  validate: {
    notOnlyWhitespace: (value: string) => {
      const trimmed = value?.trim();
      return trimmed && trimmed.length > 0 ? true : `First name cannot be empty or only whitespace`;
    },
  },
});

export const lastNameRules = () => ({
  required: {
    value: true,
    message: `Last name is required`,
  },
  maxLength: {
    value: 50,
    message: `Last name must be 50 characters or less`,
  },
  pattern: {
    value: /^[A-Za-z\s-']+$/,
    message: `Last name can only contain letters, spaces, hyphens, and apostrophes`,
  },
  validate: {
    notOnlyWhitespace: (value: string) => {
      const trimmed = value?.trim();
      return trimmed && trimmed.length > 0 ? true : `Last name cannot be empty or only whitespace`;
    },
  },
});
